class Asset {
    type = '';
    assetId = '';
    tileImageUrl = '';
    expirationDate = '';

    constructor() {
        Object.seal(this);
    }
}

export default Asset;
